import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';

const env = (import.meta as any).env || (window as any).__ENV__ || {};
const firebaseConfig = {
  apiKey: env.VITE_FIREBASE_API_KEY,
  authDomain: env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: env.VITE_FIREBASE_APP_ID,
  // measurementIdはGoogle Analytics 4を使用する場合のみ必要（オプショナル）
  ...(env.VITE_FIREBASE_MEASUREMENT_ID && {
    measurementId: env.VITE_FIREBASE_MEASUREMENT_ID,
  }),
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
// Cloud Functions（決済・返金などの callable は us-central1 にデプロイ）
export const functions = getFunctions(app, 'us-central1');